import firebase from "firebase";

// Asegurar que process.env esté disponible
// Create React App debería proporcionar esto automáticamente, pero agregamos una verificación
const getEnvVar = (key) => {
  // Create React App inyecta process.env automáticamente en tiempo de compilación
  // pero verificamos múltiples formas de acceso por si acaso
  if (typeof process !== 'undefined' && process.env) {
    return process.env[key];
  }
  // Fallback: intentar acceder desde window si está disponible (para algunos casos especiales)
  if (typeof window !== 'undefined' && window.process && window.process.env) {
    return window.process.env[key];
  }
  // Si todo falla, retornar undefined (Create React App debería haber inyectado los valores)
  return undefined;
};

const firebaseConfig = {
  apiKey: getEnvVar('REACT_APP_FIREBASE_API_KEY'),
  authDomain: getEnvVar('REACT_APP_FIREBASE_AUTH_DOMAIN'),
  databaseURL: getEnvVar('REACT_APP_FIREBASE_DATABASE_URL'),
  projectId: getEnvVar('REACT_APP_FIREBASE_PROJECT_ID'),
  storageBucket: getEnvVar('REACT_APP_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: getEnvVar('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
  appId: getEnvVar('REACT_APP_FIREBASE_APP_ID'),
  measurementId: getEnvVar('REACT_APP_FIREBASE_MEASUREMENT_ID'),
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const db = firebase.firestore();
export const storage = firebase.storage;
export const firebaseAuth = firebase.auth.Auth;
export const updateFirebase = firebase.firestore.FieldValue;
export const serverValue = firebase.database.ServerValue


export const startRecaptcha = (callback) => {
  window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier("recaptcha", {
    callback: () => {
      callback(true);
    },
    "expired-callback": () => {
      callback(false);
    },
  });
  window.recaptchaVerifier.render();
};
